import { faGripDotsVertical } from '@fortawesome/pro-solid-svg-icons/faGripDotsVertical';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'clsx';

import { CollapsibleListCaret } from './colapsible-list-caret';
import style from './collapsible-list-section-header.module.css';

import type { CollapsibleListSectionHeaderContentType } from './collapsible-list-section-header-content-types';

export const CollapsibleListSectionHeaderContent: CollapsibleListSectionHeaderContentType = ({
  children,
  active = true,
  open = false,
  dragHandleProps,
  className,
  summaryData,
  summaryDataStyle,
  openExpanderClassName,
  shouldPositionCaretRight = false,
  openCloseCaretVertical = false,
  contentClassName,
  grabberIconClassName,
  caretClassName,
}) => {
  return (
    <div className={classnames(style['expander-action'], { [style['open-border']]: open && !openExpanderClassName }, className)}>
      <div className={classnames(style['expander-header-content'], contentClassName)}>
        {!shouldPositionCaretRight && (
          <CollapsibleListCaret active={active} className={caretClassName} open={open} openCloseCaretVertical={openCloseCaretVertical} />
        )}
        <div className={style['collapsible-list-item-header-content']}>{children}</div>
        {shouldPositionCaretRight ? (
          <CollapsibleListCaret active={active} className={caretClassName} open={open} openCloseCaretVertical={openCloseCaretVertical} />
        ) : null}
      </div>
      {summaryData ? <div className={classnames(style['summary-data'], summaryDataStyle)}>{summaryData}</div> : null}
      {dragHandleProps ? (
        <div className={style['group-grabber']} {...dragHandleProps}>
          <FontAwesomeIcon className={classnames(style['group-grabber-icon'], grabberIconClassName)} icon={faGripDotsVertical} />
        </div>
      ) : null}
    </div>
  );
};
